/** 生成前用户补充一句 + 内置动作偏好（session） */
const KEY = 'thesis-generate-extras-v1'

export type ThesisGenerateAction =
  | 'continue'
  | 'outline'
  | 'expand'
  | 'polish'
  | 'review'

export type ThesisGenerateExtras = {
  action: ThesisGenerateAction
  note: string
}

const DEFAULT: ThesisGenerateExtras = { action: 'continue', note: '' }

export const THESIS_ACTIONS: { id: ThesisGenerateAction; label: string; hint: string }[] = [
  { id: 'continue', label: '接着写', hint: '承接上文，按本章契约往下写' },
  { id: 'outline', label: '补小节', hint: '补本节要点与小标题' },
  { id: 'expand', label: '扩成段', hint: '把提纲或短句写成完整段落' },
  { id: 'polish', label: '润色', hint: '学术书面语、去口语' },
  { id: 'review', label: '编审', hint: '指出结构与论证问题' },
]

export function loadGenerateExtras(): ThesisGenerateExtras {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return { ...DEFAULT }
    return { ...DEFAULT, ...JSON.parse(raw) }
  } catch {
    return { ...DEFAULT }
  }
}

export function saveGenerateExtras(patch: Partial<ThesisGenerateExtras>) {
  const next = { ...loadGenerateExtras(), ...patch }
  sessionStorage.setItem(KEY, JSON.stringify(next))
  return next
}

/** 拼进 system/user，供生成节点调用 */
export function buildExtrasSystemHint(): string {
  const { action, note } = loadGenerateExtras()
  const meta = THESIS_ACTIONS.find((a) => a.id === action)
  const lines = [
    '你是 MBA 论文写作助手，辅助学生完成开题与分章撰写，不是代写枪手。',
    `本次动作：${meta?.label || action}（${meta?.hint || ''}）`,
    '引用与数据须提示学生自行核实；用中文学术书面语。',
  ]
  if (note.trim()) lines.push(`学生补充偏好：${note.trim()}`)
  return lines.join('\n')
}
